import { render } from "./CreateDomain.vue?vue&type=template&id=9a8ac500&scoped=true"
import script from "./CreateDomain.vue?vue&type=script&lang=ts"
export * from "./CreateDomain.vue?vue&type=script&lang=ts"

import "./CreateDomain.vue?vue&type=style&index=0&id=9a8ac500&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9a8ac500"

export default script